"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvroReadable = void 0;
class AvroReadable {
}
exports.AvroReadable = AvroReadable;
//# sourceMappingURL=AvroReadable.js.map